export default __webpack_public_path__ + "static/media/venori-logotype.4bf58a10.svg";